export default __webpack_public_path__ + "ui/assets/img/infinity-icon-thick-42.svg";